import gql from "graphql-tag";

export const COMPLETE_TESTING_OF_REPORT = gql`
  mutation CompleteTestingOfReport($recordedBy: String!, $reportId: ID!) {
    completeTestingOfReport(recordedBy: $recordedBy, reportId: $reportId)
  }
`;
